import { Component } from '@angular/core';

interface StepItem {
  step: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-home-how-it-works-section',
  standalone: true,
  templateUrl: './home-how-it-works-section.component.html'
})
export class HomeHowItWorksSectionComponent {
  readonly steps: StepItem[] = [
    {
      step: 'Passo 1',
      title: 'Busque',
      description: 'Filtre por estado, cidade, tipo, valor de avaliação, valor de entrada e desconto. Veja tudo no mapa e salve seus favoritos.'
    },
    {
      step: 'Passo 2',
      title: 'Analise',
      description: 'Para cada imóvel: informações oficiais do leilão, simulação de custos, análise do entorno e validação de riscos.'
    },
    {
      step: 'Passo 3',
      title: 'Decida',
      description: 'Compare cenários de aquisição e revenda, receba alertas dos imóveis no seu perfil e não perca prazos importantes.'
    }
  ];
}
